<div class="card {{ contentClass }}">
  <div class="header">
    <dk-dash-card-menu [visible]="isMenuVisible" [items]="menuItems"> </dk-dash-card-menu>
    <div *ngIf="titleText" class="title">{{ titleText }}</div>
    <ng-content select="[filter]"></ng-content>
  </div>
  <div *ngIf="!isLoading" class="content">
    <ng-content></ng-content>
  </div>
</div>
